import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  stageContent: {
    overflow: 'scroll',
    width: 829,
  },
}));
